import type { Customer } from '../types/customer';
import type { CustomerSnapshot, CustomerSnapshotInput } from '../types/invoice';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const emptyCustomerSnapshot = (): CustomerSnapshot => ({
  name: '',
  email: null,
  phone: null,
  address: null,
});

export const customerToSnapshot = (customer: Customer): CustomerSnapshot => ({
  name: customer.display_name,
  email: customer.email,
  phone: customer.phone,
  address: customer.address,
});

const trimOrNull = (value: string | null): string | null => {
  const trimmed = value?.trim() ?? '';
  return trimmed || null;
};

export const snapshotToPayload = (snapshot: CustomerSnapshot): CustomerSnapshotInput => ({
  name: snapshot.name.trim(),
  email: trimOrNull(snapshot.email),
  phone: trimOrNull(snapshot.phone),
  address: trimOrNull(snapshot.address),
});

export const validateCustomerSnapshot = (snapshot: CustomerSnapshot): string | null => {
  const name = snapshot.name.trim();
  if (!name) {
    return 'Bill-to name is required.';
  }
  if (name.length > 255) {
    return 'Bill-to name must be 255 characters or less.';
  }

  const email = snapshot.email?.trim() ?? '';
  if (email && !EMAIL_PATTERN.test(email)) {
    return 'Bill-to email must be a valid email address.';
  }

  const phone = snapshot.phone?.trim() ?? '';
  if (phone.length > 50) {
    return 'Bill-to phone must be 50 characters or less.';
  }

  const address = snapshot.address?.trim() ?? '';
  if (address.length > 2000) {
    return 'Bill-to address must be 2000 characters or less.';
  }

  return null;
};
